module.exports = __webpack_public_path__ + "static/media/icon_profile.145018e8.svg";